import { useQuery } from "react-query";
import TranslationDetailsCacheName from "../../utils/TranslationDetailsCacheName";
import { fetchTranslationDetails } from "../../api/translationDetails";

// hook to fetch translation details
export const useFetchTranslationStats = (translationId: number) => {
  return useQuery({
    queryKey: [TranslationDetailsCacheName.getTranslationDetails(), translationId],
    queryFn: () => fetchTranslationDetails(translationId),
    refetchOnMount: true,
  });
};
